<template>
	<div class="position-relative">
	<div  
		class="p-1"   
		v-if="!isLoading && activity.registration && !alreadySignup() && !activity.cancelled">
		<md-button
		  class="md-button md-sm d-inline"
      :class="!(hayLugar() && tieneCupos()) ? 'md-secondary' : 'md-success'"
			@click="signUpClass()"
			 :disabled="!(hayLugar() && tieneCupos())"
		  v-if="!isPastDay() && activity.registration && !isGym() && !isTeacher() && !myclasses">
		  <md-icon>app_registration</md-icon>
		  <small v-if="hayLugar() && tieneCupos()">{{ $t('signUpForThisClass') }}</small>
		  <small v-if="!tieneCupos() && !isPastDay() && !isGym() && !isTeacher() && !myclasses && hayLugar()">Tu cuenta no tiene cupos para poder inscribirte</small>

	    <small v-if="!hayLugar() && !isPastDay() && activity.cupos > -1">{{ $t('noSlotsAvailable') }}</small>
		</md-button>
    <small v-if="isPastDay()" class="text-secondary">Esta clase ya paso o está cerca de comenzar</small>
	</div>

	  <div v-if="edit && !phone"  class="position-absolute top-0 right-0">
        <button class="border-round bg-primary mr-2" @click="editActivity()">
          <md-icon class="text-white cursor-pointer">edit</md-icon>
        </button>
        <button class="border-round bg-danger" @click="deleteAct()">
          <md-icon class="text-white cursor-pointer">close</md-icon>
        </button>
      </div>


	<div class="w-100">
	
	<strong>{{ activity.name }}</strong>
	<strong v-if="activity.cancelled" class="text-danger ml-2">[EVENTO CANCELADO]</strong>
		
	    <PlanningSlide
	    	v-if="planning" 
	    	            @goTo="goTo($event)" 
        :plannings="[planning]"
      />


      
	<div class="text-secondary ">
 		<strong v-if="!activity.startDate">Todos los {{daysOfWeek[activity.day]}}</strong>
	  <strong>
	  <strong v-if="activity.endTime"> de</strong><strong v-else> a las</strong>  {{ activity.startTime }} hs
	  </strong>
	   <strong v-if="activity.endTime">
	  a {{ activity.endTime }} hs
	  </strong>
	</div>
	<!-- Contador de tiempo restante para actividades del mismo día -->
	<!-- Si NO está inscrito: mostrar tiempo para inscribirse -->
	<div v-if="!isPastDay() && !isInscriptionClosed && !alreadySignup()" class="text-primary mt-2">
	  <small>
	    <md-icon class="md-sm">schedule</md-icon>
	    Tiempo restante para inscribirse: 
	    <strong>{{ timeRemaining }}</strong>
	  </small>
	</div>
	<!-- Si SÍ está inscrito: mostrar tiempo para desuscribirse -->
	<div v-if="!isPastDay() && !isUnsubscriptionClosed && alreadySignup()" class="text-danger mt-2">
	  <small>
	    <md-icon class="md-sm">schedule</md-icon>
	    Tiempo restante para desuscribirse: 
	    <strong>{{ unsubscriptionTimeRemaining }}</strong>
	  </small>
	</div>
  
	
	<!-- Mensaje cuando la inscripción ya está cerrada -->
	<div v-if="isPastDay() && isInscriptionClosed && !alreadySignup()" class="text-danger mt-2">
	  <small>
	    <md-icon class="md-sm">lock</md-icon>
	    Esta inscripción cerró hace 
	    <strong>{{ timeSinceClosed }}</strong>
	  </small>
	</div>
	
	<!-- Mensaje cuando la desuscripción ya está cerrada -->
	<div v-if="isPastDay() && isUnsubscriptionClosed && alreadySignup()" class="text-danger mt-2">
	  <small>
	    <md-icon class="md-sm">lock</md-icon>
	    Ya no se puede desuscribir (hace 
	    <strong>{{ unsubscriptionTimeSinceClosed }}</strong>)
	  </small>
	</div>


	<!-- Información sobre el cálculo de horarios -->
	<div v-if="showTimeInfo" class="mt-2 p-3 bg-light border border-radius">
	  <h6 class="text-info mb-2">
	    <md-icon class="md-sm">info</md-icon>
	    ¿Cómo calculamos los horarios?
	  </h6>
	  <div class="text-secondary small">
	    <!-- Información de la API -->
	    <div class="mb-3">
	      <h6 class="text-primary mb-2">📡 Datos de la API:</h6>
	      <p class="mb-1"><strong>startDate:</strong> <code>{{ activity.startDate || 'null' }}</code></p>
	      <p class="mb-1"><strong>startTime:</strong> <code>{{ activity.startTime || 'null' }}</code></p>
	      <p class="mb-1"><strong>Tipo de actividad:</strong> 
	        <span v-if="activity.startDate" class="badge badge-info">Fecha específica</span>
	        <span v-else class="badge badge-warning">Recurrente</span>
	      </p>
	    </div>

	    <!-- Procesamiento de datos -->
	    <div class="mb-3">
	      <h6 class="text-success mb-2">⚙️ Procesamiento:</h6>
	      <p class="mb-1"><strong>Fecha procesada:</strong> {{ getProcessedDate() }}</p>
	      <p class="mb-1"><strong>Hora procesada:</strong> {{ getProcessedTime() }}</p>
	      <p class="mb-1"><strong>Zona horaria aplicada:</strong> Argentina (UTC-3)</p>
	    </div>

	    <!-- Cálculo final -->
	    <div class="mb-3">
	      <h6 class="text-warning mb-2">🧮 Cálculo final:</h6>
	      <p class="mb-1"><strong>Hora de la actividad:</strong> {{ activity.startTime }} hs</p>
	      <p v-if="stablishment?.businessName?.inscriptionBefore">
	        <strong>Límite de inscripción:</strong> {{ getInscriptionLimitTime() }} hs 
	        ({{ stablishment.businessName.inscriptionBefore }} horas antes)
	      </p>
	      <p><strong>Hora actual (Argentina):</strong> {{ getCurrentArgentinaTime() }}</p>
	      
	      <!-- Verificación de consistencia -->
	      <div class="mt-2 p-2 bg-warning text-dark small">
	        <strong>🔍 Verificación de consistencia:</strong><br>
	        <strong>Valores usados en el cálculo real:</strong><br>
	        • Hora actual (timestamp): {{ getCurrentTimestamp() }}<br>
	        • Límite de inscripción (timestamp): {{ getLimitTimestamp() }}<br>
	        • Diferencia en ms: {{ getTimeDifference() }}<br>
	        • Tiempo restante calculado: {{ timeRemaining }}
	      </div>
	    </div>

	    <hr>
	    <p class="mb-1"><strong>📋 Explicación técnica:</strong></p>
	    <ul class="mb-0 pl-3">
	      <li><strong>startDate:</strong> Viene del backend ya en hora de Argentina (ej: "2025-09-16T18:00:00.000Z" = 18:00 AR)</li>
	      <li><strong>startTime:</strong> Hora en formato "HH:MM" (ej: "18:00") - también en hora de Argentina</li>
	      <li><strong>Combinación:</strong> Unimos startDate + startTime para crear la fecha/hora completa</li>
	      <li><strong>Zona horaria:</strong> Todo se trata como hora de Argentina (sin conversiones)</li>
	      <li><strong>inscriptionBefore:</strong> Restamos X horas para obtener el límite de inscripción</li>
	      <li><strong>Comparación:</strong> Comparamos con la hora actual de Argentina</li>
	      <li><strong>Actualización:</strong> El contador se actualiza cada segundo automáticamente</li>
	    </ul>
	  </div>
	</div>



	</div>
	<div  class="px-1 w-100">
	<small v-if="activity.registration" class="p-2">
	  <small v-if="activity.cupos > -1" class=" text-success"><md-icon class=" text-success">groups</md-icon> 
	  Quedan {{ (activity.cupos - activity.users.length) > 0 ? activity.cupos - activity.users.length : 0 }} lugares</small>
	  <small v-if="activity.cupos == null"><md-icon>groups</md-icon> {{ $t('remainingQuota') }}: 0</small>
	  <small v-if="activity.cupos == -1">{{ $t('unlimitedQuota') }}  <md-icon>all_inclusive</md-icon></small>
	  <br>
	</small>
	<span v-if="activity.registration">
	  <small v-if="!activity.consumequota" class=" text-success">
	   <md-icon class=" text-success">meeting_room</md-icon> {{ $t('anyClientCanSignUp') }}</small>
	  <small v-else class=" text-success">
	   <md-icon class=" text-success">door_front</md-icon>Clase con inscripción por cupos.</small>
  </span>
  <div  v-if="isGym()" class="w-100">
  <span class="badge badge-danger float-left" v-if="!activity.startDate">Actividad recurrente</span><br>
  <small class="text-secondary">
    <strong>Created at: {{ activity.createdAt.split('T')[0] }} {{ activity.createdAt.split('T')[1].split('.')[0] }}</strong>
  </small>
  </div>
  <br>
	<small class="badge badge-success && !myclasses" v-if="alreadySignup()">{{ $t('allready') }}</small>
	<div class="w-100">
		<md-button
			v-if="getCantUserEnrolled() && (isGym() || isTeacher())"
		  class="md-button md-sm d-inline md-success"
		  @click="openModal()">
		  <md-icon v-if="classicModal">keyboard_arrow_down</md-icon>
		  <md-icon v-else>keyboard_arrow_up</md-icon>
		  {{ $t('enrolledPeople') }}  <span v-if="activity.users && Array.isArray(activity.users)">({{activity.users.length}})</span>
		</md-button>
		<md-button
			v-if="!getCantUserEnrolled() && (isGym() || isTeacher())"
		  class="md-button md-sm d-inline md-success"
		  disabled>
		  	No hay inscriptos
		</md-button>

		<!-- Botón para inscribir usuarios manualmente -->
		<md-button
			v-if="(isGym() || isTeacher()) && !isPastDay() && hayLugar()"
		  class="md-button md-sm d-inline md-primary"
		  @click="openUsersModal()">
		  <md-icon v-if="showUsersModal">keyboard_arrow_down</md-icon>
		  <md-icon v-else>keyboard_arrow_up</md-icon>
		  Inscribir Usuarios <span v-if="users && Array.isArray(users)">({{users.length}})</span>
		</md-button>
    <div class="w-100 float-left card p-4" v-if="getCantUserEnrolled() && classicModal">
      <div class="md-autocomplete activity-user-search">
        <md-autocomplete
          v-model="participantsSearch"
          :md-options="participantsAutocompleteOptions"
          :md-open-on-focus="false"
          @md-selected="onParticipantSearchSelected"
        >
          <label>{{ $t('searchClientForClass') }}</label>
        </md-autocomplete>
      </div>
      <p v-if="participantsSearch.trim().length === 1" class="text-secondary mt-2 mb-0">
        <small>{{ $t('typeMinCharsToSearch') }}</small>
      </p>
      <p v-else-if="participantsSearch.trim().length >= 2 && filteredEnrolledUsers.length === 0" class="text-secondary mt-2 mb-0">
        <small>{{ $t('noClientsFound') }}</small>
      </p>
      <div v-for="item in filteredEnrolledUsers" :key="item._id" class="w-100">
        <div class="mt-2">
          <strong class="pl-2 text-secondary"> {{ item.name }}</strong><small class="pl-2 text-secondary"> {{ item.email }}</small>
          <small v-if="item.identifier" class="pl-2 text-secondary"> · {{ item.identifier }}</small>
          <md-button
            class="md-btn md-danger md-sm"
            v-if="(!isPastDay() && isClientGym()) || (isGym() || isTeacher())"
            @click="deleteClass(activity._id,item._id,activity.startDate)"
          >{{$t('unsubscribe')}}</md-button>
        </div>
      </div>
    </div>

    <!-- Inscribir / quitar usuarios con búsqueda -->
    <div class="w-100 float-left card p-4" v-if="showUsersModal && (isGym() || isTeacher())">
      <div class="md-autocomplete activity-user-search">
        <md-autocomplete
          v-model="enrollUserSearch"
          :md-options="enrollAutocompleteOptions"
          :md-open-on-focus="false"
          @md-selected="onEnrollUserSelected"
        >
          <label>{{ $t('searchClientForClass') }}</label>
        </md-autocomplete>
      </div>
      <p v-if="enrollUserSearch.trim().length === 1" class="text-secondary mt-2 mb-0">
        <small>{{ $t('typeMinCharsToSearch') }}</small>
      </p>
      <p v-else-if="enrollUserSearch.trim().length >= 2 && enrollUsersFiltered.length === 0" class="text-secondary mt-2 mb-0">
        <small>{{ $t('noClientsFound') }}</small>
      </p>

      <div v-if="selectedEnrollUser" class="mt-3 p-3 enroll-selected-user">
        <strong class="text-secondary">{{ selectedEnrollUser.name }}</strong>
        <small class="d-block text-secondary">{{ selectedEnrollUser.email }}</small>
        <small v-if="selectedEnrollUser.identifier" class="d-block text-secondary">{{ $t('identifier') }}: {{ selectedEnrollUser.identifier }}</small>
        <div class="mt-2">
          <md-button
            class="md-btn md-success md-sm"
            v-if="!isUserEnrolled(selectedEnrollUser._id) && !isPastDay()"
            @click="signUpUserManually(selectedEnrollUser._id)"
          >Inscribir</md-button>
          <md-button
            class="md-btn md-danger md-sm"
            v-if="isUserEnrolled(selectedEnrollUser._id) && !isPastDay()"
            @click="deleteClass(activity._id, selectedEnrollUser._id, activity.startDate)"
          >{{ $t('unsubscribe') }}</md-button>
          <small v-if="isUserEnrolled(selectedEnrollUser._id)" class="text-success ml-2">✓ Inscripto</small>
        </div>
      </div>

      <div v-for="user in enrollUsersFiltered" :key="user._id" class="w-100">
        <div
          class="mt-2 enroll-search-result"
          :class="{ 'enroll-search-result--active': selectedEnrollUser && selectedEnrollUser._id === user._id }"
          @click="selectEnrollUser(user)"
        >
          <strong class="pl-2 text-secondary">{{ user.name }}</strong>
          <small class="pl-2 text-secondary">{{ user.email }}</small>
          <small v-if="user.identifier" class="pl-2 text-secondary"> · {{ user.identifier }}</small>
          <md-button
            class="md-btn md-success md-sm"
            v-if="!isUserEnrolled(user._id) && !isPastDay()"
            @click.stop="signUpUserManually(user._id)"
          >Inscribir</md-button>
          <md-button
            class="md-btn md-danger md-sm"
            v-if="isUserEnrolled(user._id) && !isPastDay()"
            @click.stop="deleteClass(activity._id, user._id, activity.startDate)"
          >{{ $t('unsubscribe') }}</md-button>
          <small v-if="isUserEnrolled(user._id)" class="text-success ml-2">✓ Inscripto</small>
        </div>
      </div>
    </div>
    </div>
	</div>
	</div>
</template>
<script>

import { 
  getPlanningAction
} from '@/pages/Training/actions';
import { getAllUsersAction } from "@/pages/Users/actions";
import { format, addMonths, subMonths, getDay, isToday, isBefore } from 'date-fns';
import {
  formatAbsoluteDateLabel,
  isClassAfterPaymentPeriod,
} from '@/utils/dateUtils';
import { deleteClassAction, getMyClassesAction, signUpClassAction } from "@/pages/Stablishments/actions";
import PlanningSlide from '@/pages/Training/PlanningSlide.vue';
import { getProfileStablishmentsAction } from "@/pages/Stablishments/actions";
import Swal from 'sweetalert2';
import Fuse from 'fuse.js';

import permissionsMixin from '@/mixins/permissionsMixin';

export default {
  mixins: [permissionsMixin],
  name:"activity",

	created() {
			if(this.activity.planningId){
				this.getPlanning();
			}
			if((this.isGym() || this.isTeacher())){
				 this.getAll();
			}
      this.getStablishments();
	},
	data() {
		return {
			planning:false,
			classicModal: false,
			showUsersModal: false,
			openUsers:[],
			remainingCupos:false,
      defaultLogo: "/img/placeholder.jpg",
			users:[],
      allStablishments:[],
      stablishment:null,
      isLoading:true,
      daysOfWeek: ['Domingo','Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      timeRemaining: '00:00:00',
      timeSinceClosed: '00:00:00',
      unsubscriptionTimeRemaining: '00:00:00',
      unsubscriptionTimeSinceClosed: '00:00:00',
      isUnsubscriptionClosed: false,
      countdownInterval: null,
      isInscriptionClosed: false,
      showTimeInfo: false,
      enrollUserSearch: '',
      participantsSearch: '',
      selectedEnrollUser: null,
      fuseUsers: null,
		}
	},
  components: {
    PlanningSlide,
  },
  computed: {
    enrollAutocompleteOptions() {
      return this.enrollUsersFiltered.map((user) => this.userOptionLabel(user));
    },
    enrollUsersFiltered() {
      return this.filterUsersByQuery(this.users, this.enrollUserSearch);
    },
    participantsAutocompleteOptions() {
      return this.filteredEnrolledUsers.map((user) => this.userOptionLabel(user));
    },
    filteredEnrolledUsers() {
      const enrolled = this.getUserEnrolled();
      const query = (this.participantsSearch || '').trim();
      if (query.length < 2) {
        return enrolled;
      }
      return this.filterUsersByQuery(enrolled, query);
    },
  },
  props: {
    profile: {
      type: Object,
      default: () => {
        return {};
      }
    },
    myclasses: {
      type: Boolean,
      default: () => false,
    },
    activity: {
      type: Object,
      default: () => {},
    },
    phone: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    edit: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    day: {
      type: Date,
      default: () => {
        return true;
      }
    },

  },
  methods:{
    alreadySignup(){
      return this.activity.users.includes(this.profile.id);
    },
    getCantUserEnrolled(){
      const filtered = this.users.filter(user => this.activity.users.includes(user._id));
      return filtered.length
    },
    getUserEnrolled(){
      const filtered = this.users.filter(user => this.activity.users.includes(user._id));
      return filtered;
    },
    async getStablishments(){
      this.isLoading = true;

      try {
        const stablishmentsResponse = await getProfileStablishmentsAction();
        this.allStablishments = stablishmentsResponse.stablishments;
        if(this.allStablishments){
          this.stablishment = this.allStablishments[0];
        }
      } catch (error) {
        console.error('Error loading stablishments:', error);
      } finally {
        this.isLoading = false;
      }
    },
    goTo(item) {
      this.$router.push({
        name: 'PlanningView',
        params: { id: item._id, objeto: { id: item._id, planning: item } },
      });
      this.id = item._id;
      this.start();
    },
    async getPlanning(){
      const response = await getPlanningAction(this.activity.planningId);
      if (response.ok) {
        this.planning = response.planning;
      }
    },
    async getAll() {
      try {
        console.log('DEBUG getAll() ejecutándose...');
        const response = await getAllUsersAction();
        console.log('DEBUG getAll() response:', response);
        this.users = response.users
          .filter(user => user.role === 'client')
          .sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }));
        this.initUsersFuse();
        console.log('DEBUG getAll() this.users después de asignar:', this.users);
      } catch (error) {
        console.error('DEBUG getAll() error:', error);
        this.errorMessage = error.message;
      }
    },
    initUsersFuse() {
      this.fuseUsers = new Fuse(this.users, {
        keys: ['name', 'email', 'identifier'],
        threshold: 0.35,
        ignoreLocation: true,
      });
    },
    userOptionLabel(user) {
      const identifier =
        user.identifier != null && String(user.identifier).trim() !== ''
          ? ` · ${user.identifier}`
          : '';
      return `${user.name} — ${user.email}${identifier}`;
    },
    findUserByOptionLabel(label) {
      return this.users.find((user) => this.userOptionLabel(user) === label) || null;
    },
    formatQuotaFeedback(quota) {
      if (!quota) return '';
      if (quota.cupos === -1) return this.$t('unlimitedQuota');
      return `${quota.remainingCupos} ${this.$t('availableSlots')} (${quota.classesAttendedCount}/${quota.cupos || 0})`;
    },
    filterUsersByQuery(users, query) {
      const term = (query || '').trim();
      if (term.length < 2) {
        return [];
      }
      if (users === this.users && this.fuseUsers) {
        return this.fuseUsers.search(term).slice(0, 25).map((result) => result.item);
      }
      const fuse = new Fuse(users, {
        keys: ['name', 'email', 'identifier'],
        threshold: 0.35,
        ignoreLocation: true,
      });
      return fuse.search(term).slice(0, 25).map((result) => result.item);
    },
    selectEnrollUser(user) {
      this.selectedEnrollUser = user;
      this.enrollUserSearch = this.userOptionLabel(user);
    },
    onEnrollUserSelected(label) {
      this.selectedEnrollUser = this.findUserByOptionLabel(label);
    },
    onParticipantSearchSelected(label) {
      this.participantsSearch = label;
    },
    resetEnrollSearch() {
      this.enrollUserSearch = '';
      this.selectedEnrollUser = null;
    },
    resetParticipantsSearch() {
      this.participantsSearch = '';
    },
  	openModal(){
      this.classicModal = !this.classicModal;
      if (this.classicModal) {
        this.resetParticipantsSearch();
      }
  	},
    classicModalHide() {
      this.classicModal = false;
    },
  	hayLugar(){
  		return (this.activity.cupos < 0 || (this.activity.cupos - this.activity.users.length) > 0);
  	},
  	tieneCupos(){
  	  const profile = JSON.parse(localStorage.getItem('profile'));
  	  this.remainingCupos = profile.remainingCupos
			return (this.remainingCupos > 0);
  	},
    isPastDay() {
        console.log('Activity:', this.activity);
        // Si no tiene startDate, es una clase recurrente
        if(!this.activity.startDate){
            console.log('=== DEBUG isPastDay (Clase recurrente) ===');
            // Usar el día que viene como prop
            const selectedDay = new Date(this.day);
            
            // Obtener la fecha actual en Argentina (UTC-3)
            const now = new Date();
            const argentinaTime = this.getCurrentTime();
            console.log('Hora en Argentina:', argentinaTime.toLocaleString());
            
            // Crear fecha con la hora de la clase (ya está en hora de Argentina)
            const [hours, minutes] = this.activity.startTime.split(':').map(Number);
            const classTime = new Date(selectedDay);
            classTime.setHours(hours, minutes, 0, 0);
            
            console.log('Hora de la clase:', this.activity.startTime);
            console.log('Fecha seleccionada:', selectedDay.toLocaleString());
            console.log('Fecha de la clase:', classTime.toLocaleString());
            
            // Si es hoy, verificar la hora
            const selectedDayOnly = new Date(selectedDay);
            selectedDayOnly.setHours(0, 0, 0, 0);
            const todayDateOnly = new Date(argentinaTime);
            todayDateOnly.setHours(0, 0, 0, 0);
            
            if (selectedDayOnly.getTime() === todayDateOnly.getTime()) {
                console.log('Es hoy, comparando horas');
                console.log('Hora actual (AR):', argentinaTime.toLocaleString());
                console.log('Hora de la clase:', classTime.toLocaleString());
                console.log('¿Es pasado?:', argentinaTime > classTime);
                return argentinaTime > classTime;
            }

            // Si el día seleccionado es anterior a hoy, es pasado
            if (isBefore(selectedDay, argentinaTime)) {
                console.log('Es un día anterior');
                return true;
            }

            console.log('Es un día futuro');
            return false;
        }

        // Para clases con fecha específica
        console.log('=== DEBUG isPastDay (Clase con fecha específica) ===');
        let day = this.activity.startDate;
        
        // Obtener la fecha actual en Argentina (UTC-3)
        const now = new Date();
        const argentinaTime = this.getCurrentTime();
        console.log('Hora en Argentina:', argentinaTime.toLocaleString());
        
        // Crear la fecha de la actividad combinando startDate y startTime
        const activityTime = new Date(day);
        
        // Si hay startTime, combinarlo con la fecha
        if (this.activity.startTime) {
          const [hours, minutes] = this.activity.startTime.split(':').map(Number);
          activityTime.setHours(hours, minutes, 0, 0);
        }
        
        console.log('Fecha de la actividad:', activityTime.toLocaleString());
        console.log('inscriptionBefore:', this.stablishment?.businessName?.inscriptionBefore);
        console.log('unscriptionBefore:', this.stablishment?.businessName?.unnscriptionBefore);
        
        let limitTime = new Date(activityTime);
        
        if(!this.myclasses){
              // If inscriptionBefore exists and is a number, use it as hours
          if (this.stablishment?.businessName?.inscriptionBefore && !isNaN(this.stablishment.businessName.inscriptionBefore)) {
              const hoursBefore = parseInt(this.stablishment.businessName.inscriptionBefore);
              limitTime = new Date(activityTime);
              limitTime.setHours(activityTime.getHours() - hoursBefore);
              console.log('Límite de inscripción:', limitTime.toLocaleString());
          }
        }
     

        console.log('¿Es pasado?:', argentinaTime > limitTime);
        return argentinaTime > limitTime;
    },
    isTodayDay(day) {
      // Obtener la fecha actual en Argentina (UTC-3)
      const now = new Date();
      const argentinaTime = this.getCurrentTime();
      
      // La fecha viene en formato UTC, la usamos directamente
      const activityTime = new Date(day);
      
      // Comparar solo las fechas (sin hora) usando zona horaria de Argentina
      const localDate = new Date(activityTime);
      localDate.setHours(0, 0, 0, 0);
      const todayDate = new Date(argentinaTime);
      todayDate.setHours(0, 0, 0, 0);
      
      return localDate.getTime() === todayDate.getTime();
    },
    formatConfirmMessage(key, params) {
      return this.$t(key)
        .replace('{user}', params.user || '')
        .replace('{class}', params.className || '');
    },
    findUserForConfirm(userId) {
      return (
        this.users.find((u) => u._id === userId) ||
        this.getUserEnrolled().find((u) => u._id === userId) ||
        (this.selectedEnrollUser && this.selectedEnrollUser._id === userId
          ? this.selectedEnrollUser
          : null)
      );
    },
    async confirmRemoveUserFromClass(userId) {
      const user = this.findUserForConfirm(userId);
      const result = await Swal.fire({
        title: this.$t('confirmRemoveFromClassTitle'),
        text: this.formatConfirmMessage('confirmRemoveFromClassText', {
          user: user?.name || this.$t('name'),
          className: this.activity.name,
        }),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: this.$t('yesRemoveFromClass'),
        cancelButtonText: this.$t('cancel'),
      });
      return result.isConfirmed;
    },
    async deleteClass(id, userId, day) {
      const confirmed = await this.confirmRemoveUserFromClass(userId);
      if (!confirmed) {
        return;
      }

      if(this.isGym()){
        const removeResponse = await deleteClassAction(id, userId);
        const index = this.activity.users.indexOf(userId);
        if (index > -1) {
          this.activity.users.splice(index, 1);
        }
        if (this.selectedEnrollUser && this.selectedEnrollUser._id === userId) {
          this.selectedEnrollUser = null;
          this.enrollUserSearch = '';
        }

        Swal.fire({
          title: 'Usuario retirado con exito',
          text: this.formatQuotaFeedback(removeResponse.quota) || undefined,
          icon: 'success',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
        });
        return;
      }
      // If it's today's class, check the unsubscription time limit
      if (this.isTodayDay(day)) {
        const now = new Date();
        const activityTime = new Date(day);
        
        // Check if there's an unsubscription time limit
        if (this.stablishment?.businessName?.unnscriptionBefore && !isNaN(this.stablishment.businessName.unnscriptionBefore)) {
          const hoursBefore = parseInt(this.stablishment.businessName.unnscriptionBefore);
          const limitTime = new Date(activityTime);
          limitTime.setHours(activityTime.getHours() - hoursBefore);
          
          // If current time is past the limit time, prevent unsubscription
          if (now > limitTime) {
            Swal.fire({
              title: 'No puedes cancelar ahora',
              text: `Lo sentimos pero no puedes cancelar la clase cuando faltan menos de ${hoursBefore} horas para que comience. Contactate con nosotros.`,
              icon: 'warning',
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            });
            return;
          }
        }
        
        // If not gym, show the original warning
        if (!this.isGym()) {
          Swal.fire({
            title: 'No puedes cancelar ahora',
            text: 'Lo sentimos pero falta muy poco para que comience esta clase. Contactate con nosotros.',
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: false,
            confirmButtonColor: '#3085d6',
          });
          return;
        }
      }

      const removeResponse = await deleteClassAction(id, userId);
      const index = this.activity.users.indexOf(userId);
      if (index > -1) {
        this.activity.users.splice(index, 1);
      }
      if (this.selectedEnrollUser && this.selectedEnrollUser._id === userId) {
        this.selectedEnrollUser = null;
        this.enrollUserSearch = '';
      }

      Swal.fire({
        title: 'Usuario retirado con exito',
        text: this.formatQuotaFeedback(removeResponse.quota) || undefined,
        icon: 'success',
        showCancelButton: true,
        showConfirmButton: false,
        confirmButtonColor: '#3085d6',
      });

    },
  	signUpClass(){

      if (this.profile.paymentDate && isClassAfterPaymentPeriod(this.profile.paymentDate, this.day)) {
        const paymentLabel = formatAbsoluteDateLabel(this.profile.paymentDate);
        Swal.fire({
          title: 'No puedes inscribirte en esta clase',
          text: `Lo sentimos pero no puedes inscribirte en esta clase porque es después de tu fecha de pago. ${paymentLabel}`,
          icon: 'warning',
          showCancelButton: true,
          showConfirmButton: false,
          confirmButtonColor: '#3085d6',
        });
        return;
      }

  		this.$emit('signUpClass',{id: this.activity._id,day: this.day});
  	},
  	deleteAct(){
  		this.$emit('deleteAct', {
        id: this.activity._id,
        activity: this.activity,
        day: this.day,
      });
  	},
  	editActivity(){
  		this.$emit('editActivity', {...this.activity, selectedDay: this.day});
  		 const targetElement = document.getElementById('collapsetotal23');
	    if (targetElement) {
	        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
	    }
  	},
  	openUsersModal(){
      this.showUsersModal = !this.showUsersModal;
      if (this.showUsersModal) {
        this.resetEnrollSearch();
      }
  	},
  	isUserEnrolled(userId) {
      return this.activity.users.includes(userId);
    },
  	async signUpUserManually(userId) {
      const targetUser = this.users.find((u) => u._id === userId);
      if (targetUser && targetUser.canEnrollInClasses === false) {
        Swal.fire({
          icon: 'warning',
          title: this.$t('inactiveClient'),
          text: targetUser.isActiveClient === false
            ? this.$t('clientInactiveCannotEnroll')
            : this.$t('paymentExpiredCannotEnroll'),
        });
        return;
      }
      try {
        const date = new Date(this.day);
        const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
        const formattedDate = utcDate.toISOString();

        const data = {
          userId,
          activityId: this.activity._id,
          day: formattedDate
        };

        const response = await signUpClassAction(data);
        if(response.ok){
          if (!this.activity.users.includes(userId)) {
            this.activity.users.push(userId);
          }
          if (this.selectedEnrollUser && this.selectedEnrollUser._id === userId) {
            this.selectedEnrollUser = { ...this.selectedEnrollUser };
          }
          const quotaText = this.formatQuotaFeedback(response.quota);
          Swal.fire({
            icon: 'success',
            title: 'Usuario inscrito exitosamente',
            text: quotaText || 'El usuario ha sido inscrito a la clase',
          });
        } else if (response.message === 'paymentExpired') {
          Swal.fire({
            icon: 'warning',
            title: this.$t('paymentExpired'),
            text: this.$t('paymentExpiredCannotEnroll'),
          });
        } else if (response.message === 'noQuotaLeft') {
          Swal.fire({
            icon: 'warning',
            title: this.$t('noQuotaLeft'),
            text: this.formatQuotaFeedback(response.quota) || this.$t('noQuotaLeftThisMonth'),
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: response.message || 'No se pudo inscribir al usuario',
          });
        }
      } catch (error) {
        console.error('Error inscribiendo usuario:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo inscribir al usuario',
        });
      }
    },
    // Función para verificar si la actividad es del día actual
    isTodayActivity() {
      if (!this.activity.startDate) {
        // Para actividades recurrentes, verificar si el día seleccionado es hoy
        const selectedDay = new Date(this.day);
        const now = new Date();
        const argentinaTime = this.getCurrentTime();
        
        // Comparar solo las fechas (sin hora) usando zona horaria de Argentina
        const selectedDayOnly = new Date(selectedDay);
        selectedDayOnly.setHours(0, 0, 0, 0);
        const todayDateOnly = new Date(argentinaTime);
        todayDateOnly.setHours(0, 0, 0, 0);
        
        return selectedDayOnly.getTime() === todayDateOnly.getTime();
      }
      
      // Para actividades con fecha específica
      const activityDate = new Date(this.activity.startDate);
      const now = new Date();
      const argentinaTime = this.getCurrentTime();
      
      // Comparar solo las fechas (sin hora) usando zona horaria de Argentina
      const activityDateOnly = new Date(activityDate);
      activityDateOnly.setHours(0, 0, 0, 0);
      const todayDateOnly = new Date(argentinaTime);
      todayDateOnly.setHours(0, 0, 0, 0);
      
      return activityDateOnly.getTime() === todayDateOnly.getTime();
    },
    // Función para iniciar el contador
    startCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
      
      this.updateCountdown();
      this.countdownInterval = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },
    // Función para actualizar el contador
    updateCountdown() {
      if (!this.isTodayActivity()) {
        this.timeRemaining = '00:00:00';
        this.timeSinceClosed = '00:00:00';
        this.unsubscriptionTimeRemaining = '00:00:00';
        this.unsubscriptionTimeSinceClosed = '00:00:00';
        this.isInscriptionClosed = false;
        this.isUnsubscriptionClosed = false;
        return;
      }
      
      const now = new Date();
      const argentinaTime = this.getCurrentTime();
      
      // Crear la fecha de la actividad
      let activityTime;
      if (this.activity.startDate) {
        activityTime = new Date(this.activity.startDate);
        if (this.activity.startTime) {
          const [hours, minutes] = this.activity.startTime.split(':').map(Number);
          activityTime.setHours(hours, minutes, 0, 0);
        }
      } else {
        // Para actividades recurrentes
        const selectedDay = new Date(this.day);
        const [hours, minutes] = this.activity.startTime.split(':').map(Number);
        activityTime = new Date(selectedDay);
        activityTime.setHours(hours, minutes, 0, 0);
      }
      
      // Aplicar inscriptionBefore si existe
      let limitTime = new Date(activityTime);
      if (this.stablishment?.businessName?.inscriptionBefore && !isNaN(this.stablishment.businessName.inscriptionBefore)) {
        const hoursBefore = parseInt(this.stablishment.businessName.inscriptionBefore);
        limitTime = new Date(activityTime);
        limitTime.setHours(activityTime.getHours() - hoursBefore);
      }
      
      // Calcular el tiempo restante hasta el límite de inscripción
      const timeDiff = limitTime.getTime() - argentinaTime.getTime();
      
      if (timeDiff <= 0) {
        // La inscripción ya cerró, calcular cuánto tiempo hace
        this.isInscriptionClosed = true;
        const timeSince = argentinaTime.getTime() - limitTime.getTime();
        
        const hours = Math.floor(timeSince / (1000 * 60 * 60));
        const minutes = Math.floor((timeSince % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeSince % (1000 * 60)) / 1000);
        
        this.timeSinceClosed = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        this.timeRemaining = '00:00:00';
        return;
      } else {
        // Aún se puede inscribir, mostrar tiempo restante
        this.isInscriptionClosed = false;
        const hours = Math.floor(timeDiff / (1000 * 60 * 60));
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
        
        this.timeRemaining = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        this.timeSinceClosed = '00:00:00';
      }
      
      // Calcular tiempo de desuscripción
      this.updateUnsubscriptionCountdown(activityTime, argentinaTime);
    },
    // Función para actualizar el contador de desuscripción
    updateUnsubscriptionCountdown(activityTime, argentinaTime) {
      // Aplicar unnscriptionBefore si existe
      let unsubscriptionLimitTime = new Date(activityTime);
      if (this.stablishment?.businessName?.unnscriptionBefore && !isNaN(this.stablishment.businessName.unnscriptionBefore)) {
        const hoursBefore = parseInt(this.stablishment.businessName.unnscriptionBefore);
        unsubscriptionLimitTime = new Date(activityTime);
        unsubscriptionLimitTime.setHours(activityTime.getHours() - hoursBefore);
      } else {
        // Si no hay límite de desuscripción, usar el mismo límite que la inscripción
        unsubscriptionLimitTime = new Date(activityTime);
        if (this.stablishment?.businessName?.inscriptionBefore && !isNaN(this.stablishment.businessName.inscriptionBefore)) {
          const hoursBefore = parseInt(this.stablishment.businessName.inscriptionBefore);
          unsubscriptionLimitTime.setHours(activityTime.getHours() - hoursBefore);
        }
      }
      
      // Calcular el tiempo restante hasta el límite de desuscripción
      const unsubscriptionTimeDiff = unsubscriptionLimitTime.getTime() - argentinaTime.getTime();
      
      if (unsubscriptionTimeDiff <= 0) {
        // La desuscripción ya cerró, calcular cuánto tiempo hace
        this.isUnsubscriptionClosed = true;
        const timeSince = argentinaTime.getTime() - unsubscriptionLimitTime.getTime();
        
        const hours = Math.floor(timeSince / (1000 * 60 * 60));
        const minutes = Math.floor((timeSince % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeSince % (1000 * 60)) / 1000);
        
        this.unsubscriptionTimeSinceClosed = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        this.unsubscriptionTimeRemaining = '00:00:00';
      } else {
        // Aún se puede desuscribir, mostrar tiempo restante
        this.isUnsubscriptionClosed = false;
        const hours = Math.floor(unsubscriptionTimeDiff / (1000 * 60 * 60));
        const minutes = Math.floor((unsubscriptionTimeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((unsubscriptionTimeDiff % (1000 * 60)) / 1000);
        
        this.unsubscriptionTimeRemaining = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        this.unsubscriptionTimeSinceClosed = '00:00:00';
      }
    },
    // Función para obtener la hora actual de Argentina formateada
    getCurrentArgentinaTime() {
      const currentTime = this.getCurrentTime();
      return currentTime.toLocaleTimeString('es-AR', { 
        hour: '2-digit', 
        minute: '2-digit', 
        second: '2-digit' 
      });
    },
    // Función para obtener el límite de inscripción formateado
    getInscriptionLimitTime() {
      if (!this.activity.startTime) return 'No definido';
      
      const [hours, minutes] = this.activity.startTime.split(':').map(Number);
      let limitHours = hours;
      
      if (this.stablishment?.businessName?.inscriptionBefore && !isNaN(this.stablishment.businessName.inscriptionBefore)) {
        limitHours = hours - parseInt(this.stablishment.businessName.inscriptionBefore);
        // Manejar el caso donde el límite es del día anterior
        if (limitHours < 0) {
          limitHours += 24;
        }
      }
      
      return `${limitHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    },
    // Función para mostrar la fecha procesada
    getProcessedDate() {
      if (!this.activity.startDate) return 'N/A (Actividad recurrente)';
      
      // La fecha del backend ya está en hora de Argentina
      const activityDate = new Date(this.activity.startDate);
      
      return activityDate.toLocaleDateString('es-AR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },
    // Función para mostrar la hora procesada
    getProcessedTime() {
      if (!this.activity.startTime) return 'N/A';
      
      if (this.activity.startDate) {
        // Para actividades con fecha específica
        // La fecha del backend ya está en hora de Argentina
        const activityDate = new Date(this.activity.startDate);
        const [hours, minutes] = this.activity.startTime.split(':').map(Number);
        activityDate.setHours(hours, minutes, 0, 0);
        
        return activityDate.toLocaleTimeString('es-AR', {
          hour: '2-digit',
          minute: '2-digit'
        });
      } else {
        // Para actividades recurrentes
        return `${this.activity.startTime} hs (hora local)`;
      }
    },
    // Función para obtener la hora actual en Argentina
    getCurrentTime() {
      const now = new Date();
      // Convertir UTC a Argentina (UTC-3) de manera consistente
      const argentinaOffset = -3 * 60; // -3 horas en minutos
      const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
      const argentinaTime = new Date(utc + (argentinaOffset * 60000));
      return argentinaTime;
    },
    // Funciones de verificación de consistencia
    getCurrentTimestamp() {
      const argentinaTime = this.getCurrentTime();
      return argentinaTime.getTime();
    },
    getLimitTimestamp() {
      if (!this.activity.startTime) return 'N/A';
      
      let activityTime;
      if (this.activity.startDate) {
        activityTime = new Date(this.activity.startDate);
        const [hours, minutes] = this.activity.startTime.split(':').map(Number);
        activityTime.setHours(hours, minutes, 0, 0);
      } else {
        const selectedDay = new Date(this.day);
        const [hours, minutes] = this.activity.startTime.split(':').map(Number);
        activityTime = new Date(selectedDay);
        activityTime.setHours(hours, minutes, 0, 0);
      }
      
      let limitTime = new Date(activityTime);
      if (this.stablishment?.businessName?.inscriptionBefore && !isNaN(this.stablishment.businessName.inscriptionBefore)) {
        const hoursBefore = parseInt(this.stablishment.businessName.inscriptionBefore);
        limitTime = new Date(activityTime);
        limitTime.setHours(activityTime.getHours() - hoursBefore);
      }
      
      return limitTime.getTime();
    },
    getTimeDifference() {
      const current = this.getCurrentTimestamp();
      const limit = this.getLimitTimestamp();
      if (typeof current === 'number' && typeof limit === 'number') {
        return limit - current;
      }
      return 'N/A';
    }
  },
  mounted() {
    // Iniciar el contador cuando el componente se monta
    this.startCountdown();
  },
  beforeDestroy() {
    // Limpiar el intervalo cuando el componente se destruye
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
 }

 </script>

 <style>

 .right-0{
   right:0;
 }
.border-round{
border-radius: 50%;
    border: 0;
    width: 31px !important;
    height: 31px !important;
    padding: 0px !important;
}
.border-round i{
font-size: 20px !important;}

.info-button {
  min-width: 18px !important;
  width: 18px !important;
  height: 18px !important;
  padding: 0 !important;
  margin-left: 4px;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.info-button:hover {
  opacity: 1;
}

.info-button i {
  font-size: 12px !important;
  line-height: 1;
}

.activity-user-search {
  margin-bottom: 0.5rem;
}

.enroll-selected-user {
  background: #f5f5f5;
  border-radius: 6px;
}

.enroll-search-result {
  cursor: pointer;
  padding: 4px 0;
  border-radius: 4px;
}

.enroll-search-result:hover,
.enroll-search-result--active {
  background: #f0f4f8;
}

 </style>

